import { ICommandPattern } from '../interfaces/commands/command-pattern';
import { CommandPayload } from '../interfaces/commands/command-payload';

export class CommandBase {
	public pattern: ICommandPattern;
	public payload: CommandPayload;
	public excludeExecutionHistory?: boolean;

	constructor(init: Partial<CommandBase>) {
		if (!init.pattern) {
			throw new Error('The pattern is a required property.');
		}
		if (!init.payload) {
			throw new Error('The payload is a required property.');
		}
		Object.assign(this, init);
		this.pattern = init.pattern;
		this.payload = init.payload;
	}
}
